import { create } from 'zustand';
import { getModalStatus, trackModal } from '@/services/user.service';
import { getPromotionalCheckout } from '@/services/plans.service';

const useWelcomeBackModalStore = create((set, get) => ({
  // Modal state
  isOpen: false,
  isLoading: false,
  modalStatus: null,
  
  // Modal status data
  modalShownCount: 0,
  limitReached: false,
  maxShows: 5,
  eligibleForPromotion: false,
  
  // Actions
  setIsOpen: (isOpen) => set({ isOpen }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setModalStatus: (modalStatus) => set({ modalStatus }),
  
  // Check if modal should be shown
  checkModalStatus: async () => {
    try {
      set({ isLoading: true });

      const response = await getModalStatus();
      const data = response.data;

      set({
        modalStatus: data,
        modalShownCount: data.modal_shown_count,
        limitReached: data.limit_reached,
        maxShows: data.max_shows,
        eligibleForPromotion: data.eligible_for_promotion,
        isLoading: false
      });

      // Show modal if conditions are met
      const shouldShow = !data.limit_reached && data.eligible_for_promotion;
      if (shouldShow) {
        set({ isOpen: true });
      }

      return shouldShow;
    } catch (error) {
      console.error('Error checking modal status:', error);
      set({ isLoading: false });
      return false;
    }
  },
  
  // Track modal interaction
  trackModalInteraction: async () => {
    try {
      await trackModal();

      // Update local count
      const currentCount = get().modalShownCount;
      set({ modalShownCount: currentCount + 1 });
    } catch (error) {
      console.error('Error tracking modal:', error);
    }
  },
  
  // Handle accept offer
  handleAcceptOffer: async () => {
    try {
      set({ isLoading: true });

      // 1. First call promotion
      const response = await getPromotionalCheckout();
      const checkoutUrl = response.data.checkout_session.url;

      // 2. Then call track
      await get().trackModalInteraction();

      // 3. Finally redirect
      if (checkoutUrl) {
        window.open(checkoutUrl, '_blank');
      }

      // Close modal
      set({ isOpen: false, isLoading: false });
    } catch (error) {
      console.error('Error handling accept offer:', error);
      set({ isLoading: false });
    }
  },
  
  // Handle modal close
  handleClose: async () => {
    try {
      // Track the modal interaction
      await get().trackModalInteraction();
      
      // Close modal
      set({ isOpen: false });
    } catch (error) {
      console.error('Error handling modal close:', error);
      set({ isOpen: false });
    }
  },
  
  // Reset store
  reset: () => set({
    isOpen: false,
    isLoading: false,
    modalStatus: null,
    modalShownCount: 0,
    limitReached: false,
    maxShows: 5,
    eligibleForPromotion: false
  })
}));

export default useWelcomeBackModalStore;
